import { FeedbackWithDetails } from '@/common/types/databaseTypes';
import { Box, Center, Flex, Loader, Text } from '@mantine/core';
import { FeedbackCard } from '../utils/FeedbackCardRenderers';
import { useTranslation } from 'react-i18next';

interface SentFeedbackTabProps {
    sentFeedbacks: FeedbackWithDetails[] | undefined;
    isLoadingSent: boolean;
}

/**
 * 보낸 피드백 탭 컴포넌트
 */
const SentFeedbackTab = ({
    sentFeedbacks,
    isLoadingSent,
}: SentFeedbackTabProps) => {
    const { t } = useTranslation(['feedback']);

    return (
        <>
            {isLoadingSent ? (
                <Flex justify="center" align="center" h={200}>
                    <Loader />
                </Flex>
            ) : sentFeedbacks && sentFeedbacks.length > 0 ? (
                <Box
                    flex={1}
                    className="custom-scrollbar"
                    pr={16}
                    mr={16}
                    style={{
                        overflowY: 'auto',
                    }}
                >
                    {sentFeedbacks.map(feedback => (
                        <FeedbackCard
                            key={feedback.id}
                            feedback={feedback}
                            isReceived={false}
                        />
                    ))}
                </Box>
            ) : (
                <Center h="100%" py="xl" ta="center">
                    <Text c="dimmed" mt="md">
                        {t('placeHolder.sent')}
                    </Text>
                </Center>
            )}
        </>
    );
};

export default SentFeedbackTab;
